
import Vue from 'vue'
import CustomTextModal from './CustomTextModal.vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'ItemDeleteModal',
  components: {
    CustomTextModal,
    RButton,
  },
  props: {
    pending: {
      type: Boolean,
    },
    singleItemName: {
      type: String,
    },
    selectedItemsNumber: {
      type: Number,
    },
  },
  computed: {
    header(): string {
      let target = ''
      if (this.singleItemName) {
        target = ` ${this.singleItemName}`
      } else if (this.selectedItemsNumber) {
        target = ` ${this.selectedItemsNumber} items`
      }

      return `Delete${target}? `
    },
  },
})
